import React, { Fragment, useState, useContext } from "react";
import { Dialog, DialogHeader, DialogBody } from "@material-tailwind/react";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import Input from "shared/Input/Input";
import ButtonCircle from "shared/Button/ButtonCircle";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { socket } from "utils/socket";
import { AuthContext } from "context/appContext";
import { useAppDispatch } from "hooks/hooks";
import { addComment } from "redux/features/locations/locationSlice";
import toast from "react-hot-toast";
interface CommentModalProps {
  open: boolean;
  handleClose: () => void;
  locationId: string;
  locationState?: any;
  setShowLoginModal?: (show: boolean) => void;
}

const CommentModal: React.FC<CommentModalProps> = ({
  open,
  handleClose,
  locationId,
  locationState,
  setShowLoginModal,
}) => {
  const dispatch = useAppDispatch();
  const authContext = useContext(AuthContext);

  const [comment, setComment] = useState("");
  const [star, setStar] = useState(0);
  const [isCommentReqLoading, setIsCommentReqLoading] = useState(false);

  const handlePostRequest = async () => {
    if (authContext.user?.role !== "client") {
      if (setShowLoginModal) {
        setShowLoginModal(true);
        return;
      }
    }

    setIsCommentReqLoading(true);

    await dispatch(
      addComment(
        JSON.stringify({
          locationId,
          text: comment,
          like: star,
          clientId: authContext?.user?.profil?.id,
        })
      )
    ).then(() => {
      setIsCommentReqLoading(false);
      toast.success("Avis envoyé avec succès ");
      handleClose();
    });

    if (locationState?.Client?.userId !== authContext?.user?.id) {
      socket.emit("send-notification", {
        senderId: authContext?.user?.id,
        receiverId: locationState?.Client?.userId,
        action: "send_avis",
        locationId: locationState?.id,
        location: locationState,
      });
    }

    setStar(0);
    setComment("");
  };

  return (
    <Fragment>
      <Dialog open={open} handler={handleClose}>
        <DialogHeader className="text-center">Ajouter un commentaire</DialogHeader>

        <DialogBody divider className="flex flex-col justify-center">
          <div className="space-y-5">
            <FiveStartIconForRate
              iconClass="w-6 h-6"
              className="space-x-0.5"
              onRatingChange={(rating) => setStar(rating)}
            />
            <div className="relative">
              <Input
                fontClass=""
                sizeClass="h-16 px-4 py-3"
                rounded="rounded-3xl"
                placeholder="Partage tes pensées ..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
              <ButtonCircle
                loading={isCommentReqLoading}
                disabled={isCommentReqLoading}
                className="absolute transform -translate-y-1/2 right-2 top-1/2"
                size="w-12 h-12"
                onClick={handlePostRequest}
              >
                <ArrowRightIcon className="w-5 h-5" />
              </ButtonCircle>
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </Fragment>
  );
};

export default CommentModal;
